var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"pl-2 pr-2",attrs:{"app":"","id":"footer"}},[_c('img',{attrs:{"src":require('../assets/images/logo_bluchip.png'),"alt":"Bluchip","id":"bluchip_logo"}}),_c('v-spacer'),_c('div',[_vm._v("v "+_vm._s(_vm.$store.state.app_version))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }